
































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import UpdateAccountRequest from '@/models/Accounts/Shared/UpdateAccountRequest';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import AccountState from "@/models/Accounts/Shared/AccountState";

@Component({ name: 'DetailsEditDialog' })
export default class extends SaascadaVueDialog {

    request: UpdateAccountRequest = new UpdateAccountRequest();
    dateAsString: string = '';
    todaysDateAsString: string = new Date().toISOString().split('T')[0];

    @Watch('dialog')
    onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateAccountRequest();
            this.request.name = DepositAccountModule.depositAccount.name;
            this.todaysDateAsString = new Date().toISOString().split('T')[0];
            this.dateAsString = DepositAccountModule.depositAccount.reviewDateUtc ? new Date(DepositAccountModule.depositAccount.reviewDateUtc).toISOString().split('T')[0] : '';
            this.request.inboundOverrideTransactionReference = DepositAccountModule.depositAccount.inboundOverrideTransactionReference;
            this.request.outboundOverrideTransactionReference = DepositAccountModule.depositAccount.outboundOverrideTransactionReference;
        }
    }

    get isAccountStateReadOnly() {
        return DepositAccountModule.depositAccount.state === AccountState.ReadOnly;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            this.request.reviewDateUtc = new Date(this.dateAsString + "T00:00:00Z");
            await DepositAccountModule.editDepositAccount(this.request);
        }
    }

}
